import React from "react";

/**
 * LoadingOverlay - Overlay de carga para la grilla
 */
const LoadingOverlay = () => {
    return (
        <div style={styles.overlay}>
            <div style={styles.spinnerContainer}>
                <div style={styles.spinner}></div>
                <p style={styles.text}>Cargando...</p>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
    },
    spinnerContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
    },
    spinner: {
        border: "4px solid #f3f3f3",
        borderTop: "4px solid #00468B",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        animation: "spin 1s linear infinite",
    },
    text: {
        color: "#00468B",
        fontSize: "14px",
        fontWeight: "bold",
        margin: 0,
    },
};

// Agregar keyframes para la animación
if (typeof document !== 'undefined') {
    const styleSheet = document.styleSheets[0];
    const keyframes = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
    try {
        styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
    } catch (e) {
        // Ignorar si ya existe
    }
}

export default LoadingOverlay;
